/**
* DevExpress HTML/JS Reporting (viewer\documentMap\_documentMapTreeListController.js)
* Version:  23.1.6
* Build date: Oct 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
export class DocumentMapTreeListController {
    constructor() {
        this.selectedItem = ko.observable(null);
        this.clickHandler = (item) => void 0;
    }
    itemsFilter(item) {
        return true;
    }
    hasItems(item) {
        return item.isList === true;
    }
    canSelect(value) {
        return true;
    }
    select(value) {
        if (this.canSelect(value) && value !== this.selectedItem.peek()) {
            this.selectedItem.peek() && this.selectedItem.peek().isSelected(false);
            this.selectedItem(value);
            value.isSelected(true);
        }
    }
    showIconsForChildItems() {
        return false;
    }
}
